export enum EfDatatableSortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc',
  INITIAL = 'initial'
}
